import React from 'react';

const Analysis: React.FC<{ withReviews: boolean, title: string }> = ({ withReviews, title }) => {
   return (
      <></>
   );
};

export default Analysis;
